import { Colors } from '@src/colors';
import styled from 'styled-components';
import { Option } from './Option.styled';

export const Popover = styled.ul`
    position: absolute;

    background: #ffffff;
    border: 1px solid ${Colors.midnight70};
    border-radius: 8px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;

    list-style-type: none;
    padding: 0;
    margin: 0;

    max-height: 500px;
    min-width: 100%;

    overflow-x: hidden;
    overflow-y: overlay;

    ::-webkit-scrollbar {
        width: 15px;
    }

    ::-webkit-scrollbar-track {
        background: ${Colors.midnight10};
        border-radius: 8px;
        border: 4px solid transparent;
        background-clip: padding-box;
    }

    ::-webkit-scrollbar-thumb {
        background: ${Colors.midnight30};
        border-radius: 8px;
        border: 4px solid transparent;
        background-clip: padding-box;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: ${Colors.midnight40};
        border: 4px solid transparent;
        background-clip: padding-box;
    }

    > ${Option} {
        padding: 13px 20px;

        &:first-of-type {
            border-radius: 8px 8px 0 0;
        }

        &:last-of-type {
            border-radius: 0 0 8px 8px;
        }
    }
`;
